export class Filter {

	/*
	 * Init the handler
	 *
	 */
    constructor() {
        const rootClass = 'compliance-country-updates';
        const blockEls = document.querySelectorAll(`.${rootClass}`);
        blockEls.forEach((blockEl) => this.setupCheckboxes(blockEl, rootClass));
		blockEls.forEach((blockEl) => this.clearFilter(blockEl, rootClass));
    }

     /*
	 * Setup event listener for checkbox click event
	 * @param     {rootEl} the root element
	 * @return    {void}
	 */
    setupCheckboxes(rootEl) {
        this.rootEl = rootEl;
        this.ccCheckboxes = this.rootEl.querySelectorAll('input[type="checkbox"]');

        this.ccCheckboxes.forEach(el => {
            el.addEventListener('click', this.updateFilter.bind(this, el));
        });

        //this.updateCount();
    }

    /*
	 * Update the url and query with the selected filters
	 *
	 * @return    {void}
	 */
	updateFilter() {
        let setFilters = [],
            key = 'compliance-categories';
		const checkboxEls = Array.from(
			this.rootEl.querySelectorAll('input[type="checkbox"]:checked')
		);
		checkboxEls.forEach((checkboxEl) => setFilters.push(checkboxEl.value));

        let value = setFilters.toString()
        if ('URLSearchParams' in window) {
            let searchParams = new URLSearchParams(window.location.search)
            searchParams.set(key, value);
            let newRelativePathQuery = window.location.pathname + '?' + decodeURIComponent(searchParams.toString());
            history.pushState(null, '', newRelativePathQuery);
            location.reload();
        }
	}

	clearFilter(rootEl){
		this.rootEl = rootEl;
		const clearBtn = rootEl.querySelector('.clear-filter-button');
		const clearTigger = rootEl.querySelector('.clear-button');
		if(clearBtn instanceof HTMLElement && clearTigger instanceof HTMLElement){
			clearBtn.addEventListener('click',function () {
				let url = new URL(window.location.href);
				if(url.href.includes('?')){
					url.href = url.href.substr(0, url.href.indexOf('?'));
				}
				// Replace the current URL
				window.history.replaceState(
					null,
					document.title,
					decodeURI(url.toString())
				);
				location.reload();
			})
		}
	}
}
